import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {TabViewModule} from 'primeng/tabview';
import {PasswordModule} from 'primeng/password';
import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import {ChipsModule} from 'primeng/chips';
import {FileUploadModule} from 'primeng/fileupload';
import {HttpClientModule} from '@angular/common/http';
import {CheckboxModule} from 'primeng/checkbox';
import {ImageModule} from 'primeng/image';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {CalendarModule} from 'primeng/calendar';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {InputSwitchModule} from 'primeng/inputswitch';

// import {StepsModule} from 'primeng/steps';

import {TabMenuModule} from 'primeng/tabmenu';

import {CaptchaModule} from 'primeng/captcha';

const Components = [
  ReactiveFormsModule,
  FormsModule,
  InputTextModule,
  ButtonModule,
  CardModule,
  TabViewModule,
  PasswordModule,
  TableModule,
  DropdownModule,
  ChipsModule,
  ImageModule,
  CalendarModule,
  FileUploadModule,
  CheckboxModule,
  InputTextareaModule,  
  DialogModule,
HttpClientModule,
ConfirmDialogModule,
InputSwitchModule,
CaptchaModule,
TabMenuModule
];


@NgModule({
  declarations: [],
  imports: Components,
  exports: Components,
})
export class PrimeNgModule {}
